import { push } from 'connected-react-router'
import * as api from '../api'


export function loadShopData() {
    return (dispatch) => {
        dispatch({type: 'SHOP_DATA_LOADING'})
        api.shopData().then(data => {
            dispatch({type: 'SHOP_DATA_LOADED', data: data})
        })
    }
}

export function resetOrder() {
    return (dispatch, getState) => {
        dispatch({type: 'ORDER_RESET'})
    }
}

export function submitOrder() {
    return (dispatch, getState) => {
        dispatch({type: 'SHOP_BLOCKED', blocked: true})
        api.submitOrder(getState().order)
            .then(data => {
                if (data.redirect) {
                    window.location = data.redirect

                    return;
                }

                setTimeout(function() {
                    dispatch({type: 'SHOP_BLOCKED', blocked: false})
                }, 2000);
            })
            .catch(e => {
                dispatch({type: 'SHOP_BLOCKED', blocked: false})
                alert('Während des Bestellvorgangs ist ein Fehler aufgetreten. Bitte wenden Sie sich an unser Team.')
            })
    }
}

export function invoiceInfoNext() {
    return (dispatch, getState) => {
        const state = getState()

        if (state.order.type === "voucher") {
            dispatch(push('/bestellung/uebersicht'))
            return;
        }


        dispatch(push('/bestellung/teilnehmer'))
    }
}

export function invoiceInfoPrev() {
    return (dispatch, getState) => {
        const state = getState()
        console.log('push', state)
        if (state.order.type === 'voucher') {
            dispatch(push('/shop/gutschein/'))
            return
        }

        dispatch(push('/shop/'))
    }
}

export function orderStatus(data) {
    return {
        type: 'ORDER_STATUS',
        data: data
    }
}

export function voucherStatus(data) {
    return {
        type: 'VOUCHER_STATUS',
        data: data
    }
}

export function loadOrderStatus(code, signature) {
    return (dispatch, getState) => {
        dispatch(orderStatus())
        api.loadOrderStatus(code, signature)
           .then(data => dispatch(orderStatus(data)))
    }
}


export function payOrder(code, signature) {
    return (dispatch, getState) => {
        const state = getState()
        api.payOrder(state.order, code, signature)
            .then(data => {
                dispatch({type: 'SHOP_BLOCKED', blocked: false})
                if (data.redirect) {
                    window.location = data.redirect
                    return;
                }

            })
            .catch(e => {
                dispatch({type: 'SHOP_BLOCKED', blocked: false})
                alert('Während des Bezahlvorgangs ist ein Fehler aufgetreten. Bitte wenden Sie sich an unser Team.')
            })
    }
}


export function loadVoucherStatus(total, code) {
    return api.checkVoucherStatus(total, code)
}


// WEBPACK FOOTER //
// ./src/actions/index.jsx